<template>
  <div class="wrap">
    <div class="middle">
      <div class="multi-range-slider">
        <input type="range" :step="step" ref="inputLeft" id="input-left" :min="min" :max="max" :value="minVal"
          @input="setLeftValue" @change="updateRange" />
        <input type="range" :step="step" ref="inputRight" id="input-right" :min="min" :max="max" :value="maxVal"
          @input="setRightValue" @change="updateRange" />
        <div class="slider">
          <div class="track"></div>
          <div class="range" ref="bar"></div>
          <div ref="thumbLeft" class="thumb left">
            <b-img-lazy :src="require('@/assets/svg/handle.svg')" alt="handle" />
          </div>
          <div ref="thumbRight" class="thumb right">
            <b-img-lazy :src="require('@/assets/svg/handle.svg')" alt="handle" />
          </div>
        </div>
      </div>
    </div>
    <div class="values">
      <p>
        <span>min</span>
        <span class="v">{{ minValDisplay }}</span>
      </p>
      <p>
        <span>max</span>
        <span class="v">{{ maxValDisplay }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "crf-dual-range-slider",
  props: {
    format: {
      type: Function
    },
    stop: {
      type: Number,
    },
    start: {
      type: Number,
    },
    step: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    }
  },
  computed: {
    minValDisplay() {
      return this.format ? this.format(this.minVal) : this.minVal
    },
    maxValDisplay() {
      if (this.format) {
        return this.maxVal >= this.max ? `${this.format(this.max)}+` : this.format(this.maxVal);
      }
      return this.maxVal >= this.max ? `${this.max}+` : this.maxVal;
    }
  },
  watch: {
    stop: function (nMax, oMax) {
      this.$refs.inputRight.value = nMax;
      this.setRightValue();
      this.maxVal = nMax;
    },
    start: function (nMin, oMin) {
      this.$refs.inputLeft.value = nMin;
      this.setLeftValue();
      this.minVal = nMin;
    }
  },
  methods: {
    updateRange() {
      this.$emit("filter:range", [this.minVal, this.maxVal]);
    },
    setLeftValue() {
      var range = this.$refs.bar
      var _this = this.$refs.inputLeft,
        min = parseInt(_this.min),
        max = parseInt(_this.max);

      _this.value = Math.min(parseInt(_this.value), parseInt(this.$refs.inputRight.value) - this.step);
      this.minVal = Math.min(parseInt(_this.value), parseInt(this.$refs.inputRight.value) - this.step);

      var percent = ((_this.value - min) / (max - min)) * 100;
      this.$refs.thumbLeft.style.left = percent + "%";
      range.style.left = percent + "%";
    },
    setRightValue() {
      var range = this.$refs.bar
      var _this = this.$refs.inputRight,
        min = parseInt(_this.min),
        max = parseInt(_this.max);

      _this.value = Math.max(parseInt(_this.value), parseInt(this.$refs.inputLeft.value) + this.step);
      this.maxVal = Math.max(parseInt(_this.value), parseInt(this.$refs.inputLeft.value) + this.step);

      var percent = ((_this.value - min) / (max - min)) * 100;

      this.$refs.thumbRight.style.right = 100 - percent + "%";
      range.style.right = 100 - percent + "%";
    },
    // listeners:
    thumbLeftHover() {
      this.$refs.thumbLeft.classList.add("hover");
    },
    thumbLeftMouseOut() {
      this.$refs.thumbLeft.classList.remove("hover");
    },
    thumbLeftMouseDown() {
      this.$refs.thumbLeft.classList.add("active");
    },
    thumbLeftMouseUp() {
      this.$refs.thumbLeft.classList.remove("active");
    },
    thumbRightHover() {
      this.$refs.thumbRight.classList.add("hover");
    },
    thumbRightMouseOut() {
      this.$refs.thumbRight.classList.remove("hover")
    },
    thumbRightMouseDown() {
      this.$refs.thumbRight.classList.add("active");
    },
    thumbRightMouseUp() {
      this.$refs.thumbRight.classList.remove("active");
    }
  },
  data() {
    return {
      minVal: this.start ? this.start : this.min,
      maxVal: this.stop ? this.stop : this.max,
    };
  },
  beforeDestroy() {
    this.$refs.inputLeft.removeEventListener("mouseover", this.thumbLeftHover);
    this.$refs.inputLeft.removeEventListener("mousedown", this.thumbLeftMouseDown);
    this.$refs.inputLeft.removeEventListener("mouseout", this.thumbLeftMouseOut);
    this.$refs.inputLeft.removeEventListener("mouseup", this.thumbLeftMouseUp);

    this.$refs.inputRight.removeEventListener("mouseover", this.thumbRightHover);
    this.$refs.inputRight.removeEventListener("mouseout", this.thumbRightMouseOut);
    this.$refs.inputRight.removeEventListener("mousedown", this.thumbRightMouseDown);
    this.$refs.inputRight.removeEventListener("mouseup", this.thumbRightMouseUp);
  },
  mounted() {
    this.setLeftValue();
    this.setRightValue();

    this.$refs.inputLeft.addEventListener("mouseover", this.thumbLeftHover);
    this.$refs.inputLeft.addEventListener("mousedown", this.thumbLeftMouseDown);
    this.$refs.inputLeft.addEventListener("mouseout", this.thumbLeftMouseOut);
    this.$refs.inputLeft.addEventListener("mouseup", this.thumbLeftMouseUp);

    this.$refs.inputRight.addEventListener("mouseover", this.thumbRightHover);
    this.$refs.inputRight.addEventListener("mousedown", this.thumbRightMouseDown);
    this.$refs.inputRight.addEventListener("mouseout", this.thumbRightMouseOut);
    this.$refs.inputRight.addEventListener("mouseup", this.thumbRightMouseUp);
  },
};
</script>

<style scoped>
.wrap {
  margin-top: 10px;
}

div.values {
  width: 98%;
  margin: 1.5rem auto 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

div.values p {
  font-size: 12px;
  background: #fff;
  color: #cecece;
  border: 1px solid #cecece;
  padding: 0.5rem;
  border-radius: 5px;
}

span.v {
  display: block;
  color: #222;
  min-width: 60px;
}

.middle {
  position: relative;
  width: 100%;
}

.slider {
  position: relative;
  z-index: 1;
  height: 2px;
  margin: 0 20px;
}

.slider>.track {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 5px;
  background-color: #dfdfdf;
}

.slider>.range {
  position: absolute;
  z-index: 2;
  left: 25%;
  right: 25%;
  top: 0;
  bottom: 0;
  border-radius: 5px;
  background-color: #383838;
}

.slider>.thumb {
  position: absolute;
  z-index: 3;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d3d3d3;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(98, 0, 238, 0.1);
  transition: box-shadow 0.3s ease-in-out;
}

.slider>.thumb.left {
  left: 5%;
  transform: translate(-15px, -10px);
}

.slider>.thumb.right {
  right: 5%;
  transform: translate(15px, -10px);
}

.slider>.thumb.hover {
  box-shadow: 0 0 0 2px rgba(255, 101, 12, 0.1);
}

.slider>.thumb.active {
  box-shadow: 0 0 0 5px rgba(255, 101, 12, 0.2);
}

input[type="range"] {
  position: absolute;
  pointer-events: none;
  -webkit-appearance: none;
  z-index: 2;
  height: 10px;
  width: 100%;
  opacity: 0;
}

input[type="range"]::-webkit-slider-thumb {
  pointer-events: all;
  width: 30px;
  height: 30px;
  border-radius: 0;
  border: 0 none;
  background-color: red;
  -webkit-appearance: none;
}

input[type="range"]::-moz-range-thumb {
  pointer-events: all;
  width: 30px;
  height: 30px;
  border-radius: 0;
  border: 0 none;
}
</style>
